import { AutomationHistoryWithAirport, AutomationHistoryWithAirportConnectionInput, SearchTypeEnum } from '@/models/gen/graphql';

import { SearchAutomationHistoryWithAirportDocument } from '@/api/queries';
import graphApi from '@/api';

const [, runSearchAutomationHistoryWithAirport] = graphApi(SearchAutomationHistoryWithAirportDocument);

const searchAutomationHistoryWithAirport = async (id: string): Promise<AutomationHistoryWithAirport> => {
  if (!id) throw new Error('ID cannot be empty.');
  const input: AutomationHistoryWithAirportConnectionInput = {
    first: 1,
    after: null,
    query: [
      {
        id: [
          {
            values: [id],
            type: SearchTypeEnum.Or,
          },
        ],
      },
    ],
  };

  const res = await runSearchAutomationHistoryWithAirport({ input });
  return res?.searchAutomationHistoryWithAirport?.automationHistoryWithAirportConnection?.edges?.[0]?.node;
};

export default searchAutomationHistoryWithAirport;
